<template>
<div class="view contacts">

    <div class="view__inner">

        <Hero :msg="heroText"
              :padding="false" />
        <ContactsViewTextBlock />
        <CardProfileList />
        <!-- <JobBoard /> -->
        <!-- <SmileyBatch /> -->
    </div>

    <CaseBanner />
    <TheSiteFooterNew />

</div>
</template>

<script>
import {
    mapState
} from 'vuex'
import Hero from '@/components/Hero.vue'
import ContactsViewTextBlock from '@/components/ContactsViewTextBlock.vue'
import CardProfileList from '@/components/CardProfileList.vue'
import JobBoard from '@/components/JobBoard.vue'
import CaseBanner from '@/components/CaseBanner.vue'
import TheSiteFooterNew from '@/components/TheSiteFooterNew.vue'

export default {
    name: 'contact',
    components: {
        Hero,
        ContactsViewTextBlock,
        CardProfileList,
        JobBoard,
        CaseBanner,
        TheSiteFooterNew
    },
    computed: mapState({
        heroText: state => state.data.contactsPage.heading
    }),
    mounted() {
        this.$nextTick(() => this.$store.commit('SET_LIGHT_THEME', false))
    }
}
</script>

<style lang="scss">
@import "../scss/globals.scss";

.contacts {
    height: 100vh;
    z-index: 2;

    .mobile & {
        height: auto;
    }
}
</style>
